import React from 'react';
import ResponsiveWrapper from '../ResponsiveWrapper';
import { Login } from './index';
import MobileLogin from './MobileLogin';

// 아이프레임(앤츠톡 데스크탑 등 PC)에 임베드된 경우 → 데스크탑 MDM 로그인 강제
const isEmbedded = (() => {
  try {
    return window.self !== window.top;
  } catch (e) {
    return true; // cross-origin 차단 시에도 임베드로 간주
  }
})();

const ResponsiveLogin = () => {
  if (isEmbedded) {
    return <Login />;
  }
  return (
    <ResponsiveWrapper
      mobile={<MobileLogin />}
      desktop={<Login />}
    />
  );
};

export default ResponsiveLogin;
